import { useMemo as O, useCallback as y } from "react";
import { aN as F, aO as _ } from "../../vendor-CPVnY93G.js";
import { normalizeForCollation as b } from "../../utils/normalizeForCollation/index.js";
const d = new Uint32Array(65536), j = (n, r) => {
  const l = n.length, i = r.length, a = 1 << l - 1;
  let s = -1, h = 0, v = l, o = l;
  for (; o--; )
    d[n.charCodeAt(o)] |= 1 << o;
  for (o = 0; o < i; o++) {
    let f = d[r.charCodeAt(o)];
    const c = f | h;
    f |= (f & s) + s ^ s, h |= ~(f | s), s &= f, h & a && v++, s & a && v--, h = h << 1 | 1, s = s << 1 | ~(c | h), h &= c;
  }
  for (o = l; o--; )
    d[n.charCodeAt(o)] = 0;
  return v;
}, q = (n, r) => {
  const l = r.length, i = n.length, a = [], s = [], h = Math.ceil(l / 32), v = Math.ceil(i / 32);
  for (let t = 0; t < h; t++)
    s[t] = -1, a[t] = 0;
  let o = 0;
  for (; o < v - 1; o++) {
    let t = 0, u = -1;
    const M = o * 32, A = Math.min(32, i) + M;
    for (let e = M; e < A; e++)
      d[n.charCodeAt(e)] |= 1 << e;
    for (let e = 0; e < l; e++) {
      const z = d[r.charCodeAt(e)], g = s[e / 32 | 0] >>> e & 1, p = a[e / 32 | 0] >>> e & 1, w = z | t, N = ((z | p) & u) + u ^ u | z | p;
      let $ = t | ~(N | u), k = u & N;
      $ >>> 31 ^ g && (s[e / 32 | 0] ^= 1 << e), k >>> 31 ^ p && (a[e / 32 | 0] ^= 1 << e), $ = $ << 1 | g, k = k << 1 | p, u = k | ~(w | $), t = $ & w;
    }
    for (let e = M; e < A; e++)
      d[n.charCodeAt(e)] = 0;
  }
  let f = 0, c = -1;
  const m = o * 32, x = Math.min(32, i - m) + m;
  for (let t = m; t < x; t++)
    d[n.charCodeAt(t)] |= 1 << t;
  let C = i;
  for (let t = 0; t < l; t++) {
    const u = d[r.charCodeAt(t)], M = s[t / 32 | 0] >>> t & 1, A = a[t / 32 | 0] >>> t & 1, e = u | f, z = ((u | A) & c) + c ^ c | u | A;
    let g = f | ~(z | c), p = c & z;
    C += g >>> i - 1 & 1, C -= p >>> i - 1 & 1, g >>> 31 ^ M && (s[t / 32 | 0] ^= 1 << t), p >>> 31 ^ A && (a[t / 32 | 0] ^= 1 << t), g = g << 1 | M, p = p << 1 | A, c = p | ~(e | g), f = g & e;
  }
  for (let t = m; t < x; t++)
    d[n.charCodeAt(t)] = 0;
  return C;
}, L = (n, r) => {
  if (n.length < r.length) {
    const l = r;
    r = n, n = l;
  }
  return r.length === 0 ? n.length : n.length <= 32 ? j(n, r) : q(n, r);
};
function E(n = {}) {
  const { threshold: r = 2, maxLength: l = 256, sensitivity: i = "base", ...a } = n, s = { sensitivity: i, ...a }, h = F(s), v = _(s), o = O(
    () => (c) => b(c, i, v),
    [v, i]
  ), f = y(
    (c, m) => {
      if (!m)
        return !0;
      if (!c || c.length > l || m.length > l)
        return !1;
      if (h.contains(c, m))
        return !0;
      if (Math.abs(c.length - m.length) > r)
        return !1;
      const x = o(c), C = o(m);
      return x === C ? !0 : Math.abs(x.length - C.length) > r ? !1 : L(x, C) <= r;
    },
    [o, r, l]
  );
  return {
    ...h,
    fuzzyContains: f
  };
}
export {
  E as useFilter
};
